import Login from '../pages/login/login';
import Dashboard from '../pages/dashboard/dashboard';
import { Navigate } from 'react-router-dom';
import DoctorProfile from '../pages/doctorProfile/doctorProfile';
import Search from '../pages/search/search';
import ConfirmRequest from '../pages/confirmRequest/confirmRequest';
import Visits from '../pages/visits/visits';
import AppointmentDetail from '../pages/appointmentDetail/appointmentDetail';
import Questionnaire from '../pages/questionnaire/questionnaire';
import Height from '../pages/questionnaire/height/height';
import Weight from '../pages/questionnaire/weight/weight';
import SearchResult from '../pages/searchResult/searchResult';
import ReferralForm from '../pages/referralForm/referralForm';
import ReferralConfirmation from '../pages/referralConfirmation/referralConfirmation';
import ExploreArticles from '../pages/exploreArticles/exploreArticles';
import UnAuthorized from '../pages/unAuthorized/unAuthorized';
import ArticlesDetails from 'pages/articlesDetails/articlesDetails';
import Profile from 'pages/profile/profile';
import LoginVerify from 'pages/login/loginVerify';
import SelfServiceForm from 'pages/selfServiceForm/selfServiceForm';
import PracticeRegistrationUnderReview from 'pages/practiceRegistrationUnderReview/practiceRegistrationUnderReview';

export const routesConfig = [
    {
        path: "/landing",
        element: <Dashboard />,
        label: "Landing",
        requiredAuthentication: false,
        requiredPermissions: [],
    },
    {
        path: "/explore-articals",
        element: <ExploreArticles />,
        requiredAuthentication: false,
        requiredPermissions: [],
    },
    {
        path: "/articles-detail",
        element: <ArticlesDetails />,
        requiredAuthentication: false,
        requiredPermissions: [],
    },
    {
        path: "/loginverify",
        element: <LoginVerify />,
        requiredAuthentication: false,
        requiredPermissions: [],
    },
    {
        path: "/login",
        element: <Login />,
        requiredAuthentication: false,
        requiredPermissions: [],
    },
    {
        path: "/login:id",
        element: <Login />,
        requiredAuthentication: false,
        requiredPermissions: [],
    },
    {
        path: "/personalDetails",
        element: <Login />,
        requiredAuthentication: true,
        requiredPermissions: [],
    },
    {
        path: "/personalDetails:id",
        element: <Login />,
        requiredAuthentication: true,
        requiredPermissions: [],
    },
    {
        path: "/doctor-profile",
        element: <DoctorProfile />,
        requiredAuthentication: false,
        requiredPermissions: [],
    },
    {
        path: "/search",
        element: <Search />,
        requiredAuthentication: false,
        requiredPermissions: [],
    },
    {
        path: "/confirm-request",
        element: <ConfirmRequest />,
        requiredAuthentication: false,
        requiredPermissions: [],
    },
    {
        path: "/visits",
        element: <Visits />,
        requiredAuthentication: true,
        requiredPermissions: [],
    },
    {
        path: "/appointment-detail",
        element: <AppointmentDetail />,
        requiredAuthentication: true,
        requiredPermissions: [],
    },
    {
        path: "/questionnaire", ///:stepName
        element: <Questionnaire />,
        requiredAuthentication: true,
        requiredPermissions: [],
    },
    {
        path: "/profile", ///:stepName
        element: <Profile />,
        requiredAuthentication: true,
        requiredPermissions: [],
    },
    {
        path: "/height",
        element: <Height />,
        requiredAuthentication: true,
        requiredPermissions: [],
    },
    {
        path: "/weight",
        element: <Weight />,
        requiredAuthentication: true,
        requiredPermissions: [],
    },
    {
        path: "/search-result",
        element: <SearchResult />,
        requiredAuthentication: false,
        requiredPermissions: [],
    },
    {
        path: "/referral-form",
        element: <ReferralForm />,
        requiredAuthentication: true,
        requiredPermissions: [],
    },
    {
        path: "/referral-confirmation",
        element: <ReferralConfirmation />,
        requiredAuthentication: true,
        requiredPermissions: [],
    },
    {
        path: "/self-serive-form",
        element: <SelfServiceForm />,
        requiredAuthentication: false,
        requiredPermissions: [],
    },
    {
        path: "/practice-registration-under-review",
        element: <PracticeRegistrationUnderReview />,
        requiredAuthentication: false,
        requiredPermissions: [],
    },
    
    {
        path: "/",  /* Default path*/
        element: <Navigate to="/landing" />, /* Redirect to /landing*/
    },
    {
        path: "/unauthorized",
        element: <UnAuthorized />,
        requiredAuthentication: false,
        requiredPermissions: [],
    },
    
]